export { default } from 'app/developer-v3/pages/authentication/AuthenticationEditor/Container';
